import {
  LOAD_DELIVERABLE,
  SET_LOADING_DELIVERABLE,
  CREATE_COMMENT,
  CLEAR_DELIVERABLE,
  APPROVE_DELIVERABLE,
  CHANGE_SELECT_DOCUMENT_VERSION,
} from './constants';

export function loadDeliverable(deliverableId) {
  return {
    type: LOAD_DELIVERABLE,
    deliverableId,
  };
}

export function setLoadingDeliverable() {
  return {
    type: SET_LOADING_DELIVERABLE,
  };
}

export function createComment(data) {
  return {
    type: CREATE_COMMENT,
    data,
  };
}

export function clearDeliverable() {
  return {
    type: CLEAR_DELIVERABLE,
  };
}

export function approveDeliverable() {
  return {
    type: APPROVE_DELIVERABLE,
  };
}

export function changeSelectedDocumentVersion(data) {
  return {
    type: CHANGE_SELECT_DOCUMENT_VERSION,
    data,
  };
}



/** WEBPACK FOOTER **
 ** ./src/containers/deliverable/actions.js
 **/